export default __webpack_public_path__ + "static/media/Trash.4715fcfa.svg";